'use strict';//Indicating browser should run only in java script mode

EMRAdmin.factory('CommonWindowNavigationsFactory', ['CurrentEHRView','ActiveStatesToActiveViewsMapper', function (CurrentEHRView,ActiveStatesToActiveViewsMapper) {
    var CommonWindowNavigationsFactoryInstance = {

        /**
         Function to get Current Window Navigation string
         Eg:DashBoard >> Appointments Scheduler Format 2 Window >> Add Appointment Popup
         Created by Kalyani.k 
         Created on 16/12/2020
         */
        GetWindowNavigationString: function () {
            var windowNavigationString = "";
             if (!ActiveStatesToActiveViewsMapper[CurrentEHRView.view]) {
                return windowNavigationString;
             }
            //Step 1: Get Parent Tab Name and Window Name using ActiveStatesToActiveViewsMapper object
            // keys in the object are  Dash Board, Inbox,  PatientChart 1, PatientChart 2, PatientChart 3
            windowNavigationString = CommonWindowNavigationsFactoryInstance.GetCurrentWindowName();

            //Step 2: Get Current Popup Name Using ModalPopupService Scope
            windowNavigationString = CommonWindowNavigationsFactoryInstance.GetConsecutiveOpenedCurrentPopupsName(windowNavigationString);
            return windowNavigationString;

        },

        /**
         * Function to Get Current Window Name along with Current Tab Name
         * Eg: DashBoard >> Appointments Scheduler Format 2 Window
         */
        GetCurrentWindowName: function () {

            var windowNavstring = "";

            var CurrentName = ActiveStatesToActiveViewsMapper[CurrentEHRView.view].state || "";

            windowNavstring = CurrentEHRView.view + " >> ";
            windowNavstring = windowNavstring.replace("Dash Board", "Dashboard");

            windowNavstring +=  ActiveStatesToActiveViewsMapper[CurrentEHRView.view].RoutingNumber == 801 ? getSettingsAndReportsWindowName(CurrentName) : CurrentName;
            return windowNavstring.trimEnd(" >> ");
        },


        /**
         * Function to Get All Consecutive Popups names using ModalPopupService Scope
         * Eg:FirstLevel Popup Name >> Second Level Popup Name >> Third Level Popup Name >> ...nth Level Popup Name
         * @param {any} windowNavigationString
         */
        GetConsecutiveOpenedCurrentPopupsName: function (windowNavigationString) {
            //Check if even one popup is opened or not?
            if (!hasValue(angular.element("[uib-modal-window]")) || angular.element("[uib-modal-window]").length <= 0) {
                return windowNavigationString;
            }
            var ConsecutivePopupNames = "";
            //Build All Consecutive Opened Popups in string
            _.forEach(angular.element("[uib-modal-window]"), function (eachelement) {
                if (hasValue(eachelement) && hasValue(angular.element(eachelement).find(".modal-content"))) {
                    let label = angular.element(eachelement).find(".modal-content").find(".popup-header").find("navigationfrom")[0] || angular.element(eachelement).find(".modal-content").find(".popup-header").find("label")[0];
                    ConsecutivePopupNames = `${label && label.innerHTML  || ""} >> ${ConsecutivePopupNames}`;
                }
            });
            ConsecutivePopupNames = ConsecutivePopupNames.trimEnd(" >> ");
            return windowNavigationString + " >> " + ConsecutivePopupNames;
        },
    }
    return CommonWindowNavigationsFactoryInstance;
    //angular.forEach(Object.keys(ROUTINGTYPE),function(each){finalString=finalString+" case "+each+": "+"return \""+each.substring(each.indexOf("$$")+2).replaceAll("_"," ")+"\";"+"break";})
    function getSettingsAndReportsWindowName(CurrentName) {
        var SettingsWindowName = "View Dashboard Top Menus Customization";

        if (hasValue(CurrentName) && CurrentName.length > 1)
            SettingsWindowName = CurrentName.substring(0, CurrentName.length - 1);

        if (hasValue(angular.element($("#frmsettingsMenuCustomization"))) && hasValue(angular.element($("#frmsettingsMenuCustomization")).scope())
            && hasValue(angular.element($("#frmsettingsMenuCustomization")).scope().settingsMenuCustomizationSelectReport))
            SettingsWindowName = SettingsWindowName + " >> " + angular.element($("#frmsettingsMenuCustomization")).scope().settingsMenuCustomizationSelectReport;

        return SettingsWindowName;
    }
}]);